import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'

export default class extends Controller {
  static values = { type: { type: String, default: 'cpf' } }

  connect() {
    this.applyMask()
    this.observeTypeChange()
  }

  disconnect() {
    this.mask?.destroy()
  }

  typeValueChanged() {
    this.applyMask()
  }

  applyMask() {
    this.mask?.destroy()

    const maskOptions = this.getMaskOptions()
    if (maskOptions) {
      this.mask = IMask(this.element, maskOptions)
    }
  }

  getMaskOptions() {
    if (this.typeValue === 'cpf') {
      return { mask: '000.000.000-00' }
    }
    return null
  }

  observeTypeChange() {
    const form = this.element.closest('form')
    const typeSelect = form?.querySelector('[name*="document_type"]')

    if (typeSelect) {
      typeSelect.addEventListener('change', (e) => {
        this.typeValue = e.target.value
        this.element.value = ''
      })
    }
  }
}
